// 단위는 평, 만원 기준(생산량,영농대행 단가는 unit 단위로 저장되어있음)
// 서버에 보낼때 제곱미터, 원으로 변경 필요
export interface AnalysisForm {
  pnu: string;
  unit: AreaUnit;
  allArea: number;
  area: number; // 자경면적
  farmAgentArea: number; // 영농대행 면적
  // farmAgentRevenue: number; // 영농대행 연 매출
  farmAgentUnitPrice: number; // 영농대행 단가-> unit 단위로 저장
  farmAgentCost: number; // 영농대행 연 비용
  farmAgentRate: number; // 영농대행 비용 비율
  crop: string; // 작물
  // crops: number; // 기작
  quantity: number; //  생산량  -> unit 단위로 저장
  sales: number; // 연 매출
  unitPrice: number; // kg 당 단가
  growthDays: number; // 생육일수
  rainyDays: number; // 우천일수
  monthDays: number; // 월 일수
  lossDays: number; // 월 휴일
  lossMachineDays: number; // 기계 정비일
  workingHours: number; // 하루 평균 작업시간
  efd: number; // 유효일계수
  avgWorkingHours: number; // 일평균 작업시간
  isCostYear: boolean; // 비용 기준 "연"인지 여부
  financialCost: number; // 연 금융비
  empLaborCost: number; // 연 고용노동비
  ownLaborCost: number; // 연 자가노동비
  isOwnLabor: boolean; // 자가노동비 여부
  initialOwnLabor: number; // 자가노동비 기본값
  landCost: number; // 연 토지비
  materialCost: number; // 연 재료비
  waterHeatingCost: number; // 연 수도광열비
  farmEquipmentRentalCost: number; // 연 농구렌탈비
  sga: number; // 연 기타 판매관리비
  tractorList: TractorItem[];
  tractorPurchaseCost: number; // 트랙터 총 구입비
  tractorMaintenanceCost: number; // 트랙터 총 유지비
  tractorNum: number; // 트랙터 총 대수
  implementList: AccessoryItem[];
  weights: {
    tractorPower: number; // 트랙터 마력 중요도
    workEnvironment: number; // 농지 상태 중요도
    soilCondition: number; // 토양 상태 중요도
    slope: number; // 지형 경사 중요도
    skillAndEquipment: number; // 작업 숙련도 및 장비 상태 중요도
  };
  fieldConditions: {
    tractorPowerRange: string; // 트랙터 마력대
    workEnvironment: string; // 작업환경
    soilCondition: string; // 토양 상태
    slope: string; // 지형 경사
    skillAndEquipment: number; // 작업 숙련도 및 장비 상태
  };
}

export const initialForm: AnalysisForm = {
  pnu: "",
  unit: "평",
  allArea: 0,
  area: 0,
  farmAgentArea: 0,
  // farmAgentRevenue: 0,
  farmAgentUnitPrice: 0,
  farmAgentCost: 0,
  farmAgentRate: 30,
  crop: "논콩",
  // crops: 1,
  quantity: 0,
  sales: 0,
  unitPrice: 4800,
  growthDays: 180,
  rainyDays: 0,
  monthDays: 30,
  lossDays: 1,
  lossMachineDays: 2,
  workingHours: 11,
  efd: 0,
  avgWorkingHours: 0,
  isCostYear: true,
  financialCost: 0,
  empLaborCost: 0,
  ownLaborCost: 0,
  isOwnLabor: false,
  initialOwnLabor: 0,
  landCost: 0,
  materialCost: 0,
  waterHeatingCost: 0,
  farmEquipmentRentalCost: 0,
  sga: 0,
  tractorList: [],
  tractorPurchaseCost: 0,
  tractorMaintenanceCost: 0,
  tractorNum: 0,
  implementList: [],
  weights: {
    tractorPower: 60,
    workEnvironment: 20,
    soilCondition: 10,
    slope: 10,
    skillAndEquipment: 0,
  },
  fieldConditions: {
    tractorPowerRange: "PTO 51~70 hp",
    workEnvironment: "보통",
    soilCondition: "양호",
    slope: "평지",
    skillAndEquipment: 90,
  },
};

export const cropList = ["논콩", "벼"];
export type AreaUnit = "평" | "m²" | "ha" | "10a";
export const areaUnitList: AreaUnit[] = ["평", "m²", "ha", "10a"];

export interface AccessoryItem {
  implement: string; // 부속기명
  periodDays: number; // 일수
  speed: number; // 속도
  width: number; // 사용폭
  units: number; // 대수
  price: number; //  단가
  maintenance: number; // 유지비
}

export interface TractorItem {
  id: number;
  brand: string;
  model: string;
  engine_ps: number;
  pto_ps: number;
  price: number;
  desc: string;
  max_support_fund: number;
  cnt?: number;
}

export interface TestItem {
  name: string;
  capacity: number;
  recommendCapacity: number;
  units: number;
  recommendUnits: number;
}

export interface ReportSummary {
  address: string;
  area: number;
  crop: string;
  crops: number;
}

export interface TractorEfficiencyTask {
  name: string;
  group: number;
  periodDays: number;
  implement: string;
  speed: number;
  eff: number;
  width: number;
  price: number;
  maintenance: number;
  units: number;
  capacity: number;
  requiredCapacity: number;
  requiredUnits: number;
}

export interface ReportTractorEfficiency {
  summary: {
    tractorNum: number;
    implementNum: number;
    requiredImplementNum: number;
    requiredTractorNum: number;
  };
  groupTasks: {
    group1: number;
    group2: number;
    group3: number;
  };
  tasks: TractorEfficiencyTask[];
  test: TestItem[];
}

export interface FarmComparison {
  quantity: number;
  unitPrice: number;
  empLaborCost: number;
  ownLaborCost: number;
  materialCost: number;
  waterHeatingCost: number;
  farmEquipmentRentalCost: number;
  sga: number;
  totalSales: number;
  totalProductionCost: number;
  totalCost: number;
  income: number;
  financeCost: number;
  tractorMaintenanceCost: number;
  implementMaintenance: number;
}

export interface ReportFarmEconomic {
  summary: {
    totalSales: number;
    totalIncome: number;
    totalProductionCost: number;
    totalQuantity: number;
    roi: number;
    bep: number;
    totalSalesWithFarmAgent: number;
    totalIncomeWithFarmAgent: number;
    totalProductionCostWithFarmAgent: number;
    roiWithFarmAgent: number;
    bepWithFarmAgent: number;
  };
  farmComparison: FarmComparison[];
  roi: {
    tractorPurchaseCost: number;
    implementPurchaseCost: number;
    totalInvestment: number;
    totalIncome: number;
    totalIncomeWithFarmAgent: number;
    roi: number;
    roiWithFarmAgent: number;
    fixedCost: number;
    variableCost: number;
    costRoi: number;
  };
  bep: {
    totalInvestment: number;
    totalIncome: number;
    totalIncomeWithFarmAgent: number;
    bep: number;
    bepWithFarmAgent: number;
  };
}
